<script>
import {Bar} from 'vue-chartjs'
import {Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale} from 'chart.js'
import {myMixins} from "../../mixins/myMixins";
import {agentsService} from "../../../Services/Agents.service";

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
    name: "quoter-by-agent",
    mixins: [myMixins],
    components: {Bar},
    data() {
        return {
            show: false,
            isBusy: false,
            dataGraph: [],
            agentsData: [],
            chartData: {
                labels: ['January', 'February', 'March'],
                datasets: [{data: [40, 20, 12]}]
            },
            chartOptions: {
                responsive: true,
                plugins: {
                    legend: {
                        display: true,
                        position: 'top',
                        labels: {
                            color: 'black'
                        }
                    },
                },
                scales: {
                    x: {
                        title: {
                            display: true,
                            text: 'NUM. AGENTES',
                            ticks: {
                                color: 'red',
                            }
                        }
                    },
                    y: {
                        title: {
                            display: true,
                            text: 'TOTAL DE COTIZACIONES',
                            color: 'Black'
                        }
                    }
                }
            }
        }
    },
    methods: {
        async index() {
            this.isBusy = true;
            this.dataGraph = await agentsService.getMany(this.params);
            this.isBusy = false;
            const labels = [];
            const approvedData = [];
            const notApprovedData = [];

            this.dataGraph.forEach(agent => {
                labels.push(agent.id);
                //labels.push('');
                const approved = agent.relquotings.filter(quoting => quoting.approved_at !== null).length;
                const notApproved = agent.relquotings.filter(quoting => quoting.approved_at === null).length;
                approvedData.push(approved);
                notApprovedData.push(notApproved);

                this.agentsData.push({
                    id: agent.id,
                    name: agent.comisionista,
                    quoters: approved + notApproved,
                });
            });

            if (Array.isArray(approvedData) && approvedData.length) {
                this.chartData = {
                    labels: labels,
                    datasets: [
                        {
                            label: 'Aprobadas',
                            data: approvedData,
                            backgroundColor: 'rgba(75, 192, 192, 0.2)',
                            borderColor: 'rgba(75, 192, 192, 1)',
                            borderWidth: 1
                        },
                        {
                            label: 'No Aprobadas',
                            data: notApprovedData,
                            backgroundColor: 'rgba(255, 99, 132, 0.2)',
                            borderColor: 'rgba(255, 99, 132, 1)',
                            borderWidth: 1
                        }
                    ]
                };

            } else {
                console.error('approvedData is not an array or does not contain data');
            }


        },

    },
    mounted() {
        this.index();
    }
}
</script>

<template>
    <div class="view">
        <div class="row">
            <div class="col-12 col-sm-3">
                <h5>AGENTES ACTIVOS</h5>
                <ul id="listAgent" class="mt-4 quoter_info">
                    <li v-for="agent in agentsData">
                        <strong>{{ agent.id }}</strong> {{ agent.name }}
                        <span class="float-end badge rounded-pill text-bg-blue">
                                {{ agent.quoters }}
                            </span>
                    </li>
                </ul>
            </div>
            <div class="col-12 col-sm-9">
                <Bar
                    id="my-chart-id"
                    :options="chartOptions"
                    :data="chartData"
                />
            </div>

        </div>
    </div>

</template>

<style scoped>

</style>
